module.exports = __webpack_public_path__ + "static/og_racism-268a7e7873bec0d5e1a0fe25363c4114.jpg";